<style lang="less" scoped>
  @import "../../../style/theme.less";

</style>

<template>
  <div>
    <a-row type="flex" style="margin-bottom: 8px" :gutter="[16, 16]">
      <a-col flex="auto">
        <a-page-header title="Admin Users" style="padding: 0" />
      </a-col>

      <transition name="fade-in-out">
        <a-col flex="200px" v-if="showUserCreate">
          <a-input placeholder="Username" v-model="userCreateInputs.username">
            <a-icon slot="prefix" type="user"/>
          </a-input>
        </a-col>
      </transition>

      <transition name="fade-in-out">
        <a-col flex="200px" v-if="showUserCreate">
          <a-input type="password" placeholder="Password" v-model="userCreateInputs.password">
            <a-icon slot="prefix" type="lock" />
          </a-input>
        </a-col>
      </transition>

      <a-col flex="100px" v-if="showUserCreate">
        <a-button
          type="primary"
          shape="circle"
          icon="save"
          @click="() => createUser(userCreateInputs).then(updateUserList)"
        />
        <a-divider type="vertical" />
        <a-button type="primary" shape="circle" icon="close"  @click="() => { showUserCreate = false; userCreateInputs = {} }"/>
      </a-col>

      <a-col flex="100px" v-else>
        <a-button type="primary" shape="circle" icon="plus" @click="() => showUserCreate = true"/>
        <a-divider type="vertical" />
        <a-button type="primary" shape="circle" icon="reload" @click="updateUserList"/>
      </a-col>
    </a-row>

    <a-table
      :columns="columns"
      :data-source="users"
      :pagination="pagination"
      :rowKey="({ id }) => id"
      @change="updateUserList"
    >

      <template
        v-for="col in ['username', 'password']"
        :slot="col"
        slot-scope="text, record"
      >
        <div :key="col">
          <a-input
            v-if="record.editable"
            style="margin: -5px 0"
            :value="text"
            :placeholder="col"
            @change="e => setUserProperty({ id: record.id, property: col, value: e.target.value })"
          />
          <template v-else-if="col === 'password'">
            &bull;&bull;&bull;&bull;&bull;&bull;&bull;&bull;
          </template>
          <template v-else>
            {{ text }}
          </template>
        </div>
      </template>

      <span slot="timestamp" slot-scope="data">{{ data | timestamp }}</span>

      <span slot="actions" slot-scope="record">
        <span v-if="record.editable">
          <a-popconfirm title="Are you sure you want to save your changes?" @confirm="() => updateUser(record.id).then(updateUserList)">
            <a-button type="primary" shape="circle" icon="save"/>
          </a-popconfirm>

          <a-divider type="vertical" />

          <a-button type="primary" shape="circle" icon="close" @click="() => { setUserEditable({ id: record.id, editable: false }); updateUserList() }"/>
        </span>

        <a-button v-else type="primary" shape="circle" icon="edit" @click="() => setUserEditable({ id: record.id, editable: true })"/>

        <a-divider type="vertical" />

        <a-popconfirm title="Are you sure you want to delete this user?" @confirm="() => removeUser(record.id).then(updateUserList)">
          <a-button type="primary" shape="circle" icon="delete"/>
        </a-popconfirm>
      </span>
    </a-table>
  </div>
</template>

<script>

import { mapState, mapActions, mapMutations } from 'vuex';

const columns = [
  {
    title: 'User ID',
    dataIndex: 'id',
    ellipsis: true,
  }, {
    title: 'Username',
    dataIndex: 'username',
    scopedSlots: { customRender: 'username', },
  }, {
    title: 'Password',
    dataIndex: 'password',
    scopedSlots: { customRender: 'password', },
  }, {
    title: 'Created At',
    dataIndex: 'createdAt',
    scopedSlots: { customRender: 'timestamp', },
  }, {
    title: 'Updated At',
    dataIndex: 'updatedAt',
    scopedSlots: { customRender: 'timestamp', },
  }, {
    width: '240px',
    align: 'right',
    scopedSlots: { customRender: 'actions', },
  },
];

export default {
  name: 'admin.users',

  data: () => ({
    columns,

    userCreateInputs: {},
    showUserCreate: false,

    pagination: {
      current: 1,
      position: 'bottom',
      pageSize: 10,
      total: 0,
      size: 'small',
      showSizeChanger: true,
      pageSizeOptions: ['10', '20', '50',],
      showTotal: (total, range) => `${range.join('-')} of ${total}`,
    },
  }),

  mounted() {
    return this.updateUserList();
  },

  computed: mapState('admin', ['users',]),

  methods: {
    ...mapActions('admin', ['listUsers', 'removeUser', 'updateUser', 'createUser',]),
    ...mapMutations('admin', ['setUserEditable', 'setUserProperty',]),

    updateUserList({ current = this.pagination.current, pageSize = this.pagination.pageSize, } = {}) {
      this.pagination.current = current;
      this.pagination.pageSize = pageSize;

      this.showUserCreate = false;
      this.userCreateInputs = {};

      return this.listUsers({
        query: {
          $limit: pageSize,
          $skip: (current - 1) * pageSize,
        },
      }).then(({ total, }) => { this.pagination.total = total; });
    },
  },
};
</script>
